import useAvailableRoomsMessage from 'hooks/optimizely/useAvailableRoomsMessage';

export const GetShowCtaMessage = (allocationsAvailable) => {
  const { showMessage, max_rooms_cutoff } = useAvailableRoomsMessage();

  const availableRoomsMaxCutoff = max_rooms_cutoff ?? 5;
  const showCtaMessage = showMessage && allocationsAvailable && allocationsAvailable > 0 && allocationsAvailable <= availableRoomsMaxCutoff;
  return !!showCtaMessage;
};
